module.exports = __webpack_public_path__ + "static/media/tiny-checkers.63cd5fe8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pattern/tiny-checkers.svg
 ** module id = 158
 ** module chunks = 0
 **/